import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { environment } from '@env/environment';
import { DefaultLayoutComponent } from './layout/default-layout/default-layout.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { AuthGuard } from './shared/auth/auth-guard';
import { AccountInformationComponent } from './shared/components/account-information/account-information.component';
import { UserAdministrationComponent } from '@shared/components/user-administration/user-administration.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';

const routes: Routes = [
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      { path: '', redirectTo: 'welcome', pathMatch: 'full' },
      { path: 'account-information', component: AccountInformationComponent, canActivate: [AuthGuard] },
      { path: 'welcome', component: WelcomeComponent },
      {
        path: 'sessions',
        loadChildren: () => import('./shared/components/sessions/sessions.module').then(m => m.SessionsModule)
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [ AuthGuard ]
      },
      {
        path: "user-management",
        component: UserAdministrationComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "in-home-care",
        loadChildren: () => import('./components/in-home-care/in-home-care.module').then(m => m.InHomeCareModule)
      },
      {
        path: "hospital",
        loadChildren: () => import('./components/hospital/hospital.module').then(m => m.HospitalModule)
      },
      {
        path: 'hemo-tech',
        loadChildren: () => import('./components/hemo-tech/hemo-tech.module').then(m => m.HemoTechModule)
      }
    ],
  },
  { path: '**', redirectTo: 'training' },
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: environment.useHash,
      initialNavigation: !isIframe ? "enabledNonBlocking" : "disabled"
    })
  ],
  exports: [RouterModule],
  declarations: [
  ]
})
export class RoutesRoutingModule { }
